// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import resetStyles from "../styles/reset.module.scss"
import classNames from "classnames"
import React from "react"
import { NodeWithChildren } from "../helpers/node-with-children"
import { PrimitiveBaseProps, PrimitiveWithSizing, PrimitiveWithChildrenProps } from "../helpers/types"

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    PrimitiveBaseProps<HTMLButtonElement>,
    PrimitiveWithSizing,
    PrimitiveWithChildrenProps {}

export const Button = (props: ButtonProps) => {
  const {
    innerRef,
    className,
    type = "button",
    "data-node-id": dataNodeId,
    direction,
    spacing,
    alignment = "start",
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props
  return (
    <NodeWithChildren
      direction={direction}
      spacing={spacing}
      alignment={alignment}
      mainAxisSizing={mainAxisSizing}
      crossAxisSpacing={crossAxisSizing}
    >
      {(nodeWithChildrenClassName) => (
        <button
          {...otherProps}
          className={classNames(resetStyles.reset, className, nodeWithChildrenClassName)}
          type={type}
          ref={innerRef}
          data-node-id={dataNodeId}
        />
      )}
    </NodeWithChildren>
  )
}
